// extracted by mini-css-extract-plugin
module.exports = {"containerAbas":"ContainerRefeicoes_containerAbas__9BAQL"};